module.exports = __webpack_public_path__ + "img/People.b325fd7c.svg";